import { useT } from '../i18n';

// Task statuses are the task board's columns (grid_columns, kanban). Their
// labels are stored in English ("To Do", "In Progress", "Done", "Blocked") and
// recognised by label (utils/stages.ts, server side too), so they are kept as
// they are and translated where shown. An unknown label shows as stored.
const STATUS_KEY: Record<string, string> = {
  'backlog': 'taskDetail.colBacklog',
  'to do': 'taskDetail.colTodo',
  'todo': 'taskDetail.colTodo',
  'in progress': 'taskDetail.colInProgress',
  'done': 'taskDetail.colDone',
  'blocked': 'taskDetail.colBlocked',
  'archived': 'taskDetail.colArchived',
  'archivées': 'taskDetail.colArchived',
};

/** A task status (column label) in the interface language. */
export function taskStatusName(label: string | null | undefined, t: (key: string) => string): string {
  const key = STATUS_KEY[(label ?? '').trim().toLowerCase()];
  return key ? t(key) : (label ?? '');
}

/** taskStatusName with the current language. */
export function useTaskStatusName() {
  const { t } = useT();
  return (label: string | null | undefined) => taskStatusName(label, t);
}
